import { ErrorKey } from '../app-active-error/ErrorKey';
import { Auth } from '../auth/authUtils';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { OAuthToDataToken, oAuthToLoginFunction } from '../oauth/OAuthMapping';
import { setIsNewUser } from '../store/app/action-creators';
import { existingOAuthUser, oAuthExistingAuthFailed } from '../store/auth/action-creators';
import { setError } from '../store/error/action-creators';
import { reloadFlow } from '../store/flow/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
const LOG = Logger.getLogger('onOAuthExistingUser');
export const onOAuthExistingUser = (state, provider) => dispatch => {
  const token = getSignupDataValue(state, OAuthToDataToken[provider]);
  const oAuthLogin = oAuthToLoginFunction[provider];
  oAuthLogin(token).then(() => {
    return dispatch(Auth.init()).then(response => {
      if (response) {
        dispatch(existingOAuthUser(response.email, provider));
        dispatch(setIsNewUser(false));
        dispatch(reloadFlow());
      }
    });
  }).catch((error = {}) => {
    LOG.warn(`Error verifying ${provider} oauth on login service`, {
      extra: getSentryExtra(error)
    });
    dispatch(oAuthExistingAuthFailed(provider));
    dispatch(setError(ErrorKey.OAuthExistingLoginFailed, error));
  });
};